//
import React, { useState, lazy, Suspense, useEffect } from "react";
import axios from "axios";
import "./App.css";
import Loader from "./components/PostEvent/Loader";
import MediaQuery from "react-responsive";
import CacheBuster from 'react-cache-buster';
import { CookieSetting } from "cookiesetting-component";
import appversion from '../package.json';
import jsonData from "./components/ai-branding.json"; // Import the JSON file


const Body = lazy(() => import("./components/PostEvent/Body/Body"));
const BodyMobile = lazy(() => import("./components/PostEvent/Body/Bodymobile"));
const LogoMobile = lazy(() =>
  import("./components/PostEvent/Logo Section/Logomobile.js")
);
const Logo = lazy(() => import("./components/PostEvent/Logo Section/Logo.js"));
const Footer = lazy(() => import("./components/PostEvent/Footer/Footer"));
const SignUpForm = lazy(() =>
  import("./components/PostEvent/ContactUS/SignUpForm.js")
);
const Video = lazy(() => import("./components/PostEvent/video.js"));
const PostEventMemories = lazy(() =>
  import("./components/PostEvent/PostEventMemories/PostEventMemories.js")
);
// const MobilePostEventMemories = lazy(() =>
//   import("./components/PostEvent/PostEventMemories/MobilePostEventMemories.js")
// );
const Thankyou = lazy(() =>
  import("./components/PostEvent/ThankYou/Thankyou.js")
);
const SubscribeForEventNotifications = lazy(() =>
  import(
    "./components/PostEvent/SubscribeNotification/SubscribeForEventNotifications.js"
  )
);
const VideoHighlights = lazy(() =>
  import("./components/PostEvent/VideoHighlights/VideoHighlights.js")
);
const MemoriesHighlights = lazy(() =>
  import("./components/PostEvent/MemoryHighlight/MemoriesHighlight.js")
);
const PostSocial = lazy(() =>
  import("./components/PostEvent/PostSocial/PostSocial.js")
);
const PostEventVideo = lazy(() =>
  import("./components/PostEvent/PostEventVideos/PostEventVideos.js")
);
const MobilePostEventVideo = lazy(() =>
  import("./components/PostEvent/PostEventVideos/MobilePostEventVideo.js")
);

function App() {
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const imgCDNURL = process.env.REACT_APP_POSTAMAZINGMORGAN_CDN_URL;
  const appVersion = appversion.version;
  const [links, setLinks] = useState(null); // Set initial state as null

  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };

useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <div className="bodyContainer">
       <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      >
        <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    

      <MediaQuery minWidth={992}>
        <Suspense fallback={<div />}>
          <Body links={links} handleVideo={handleVideo} videoToggle={videoToggle} />
        </Suspense>
      </MediaQuery>
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <BodyMobile links={links} handleVideo={handleVideo} videoToggle={videoToggle} />
        </Suspense>
      </MediaQuery>
    
        <Suspense fallback={<div />}>
          <Logo />
        </Suspense>
      {/* </MediaQuery>
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <LogoMobile />
        </Suspense>
      </MediaQuery> */}
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <SignUpForm />
        </Suspense>
      </MediaQuery>

      <MediaQuery minWidth={992}> 
      <Suspense fallback={<div />}> 
        <PostEventVideo handleVideo={handleVideo} videoToggle={videoToggle} />
      </Suspense>
      </MediaQuery>
      <MediaQuery maxWidth={991}> 
      <Suspense fallback={<div />}> 
        <MobilePostEventVideo handleVideo={handleVideo} videoToggle={videoToggle} />
      </Suspense>
      </MediaQuery>
     
        <Suspense fallback={<div />}>
          <PostEventMemories />
        </Suspense>
      
      <Suspense fallback={<div />}>
        <Thankyou />
      </Suspense>
      <Suspense fallback={<div />}>
        <SubscribeForEventNotifications />
      </Suspense>
      <Suspense fallback={<div />}>
        <VideoHighlights />
      </Suspense>
      <Suspense fallback={<div />}>
        <MemoriesHighlights links={links}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      <Suspense fallback={<Loader />}>
        {played && (
          <Video handleVideo={handleVideo} videoToggle={videoToggle} />
        )}
      </Suspense>
      </CacheBuster>
    </div>
  );
}

export default App;
